import { createSelector } from '@ngrx/store';

import { AppState } from '../state';
import { FullscreenLoaderModel } from './fullscreen-loader.model';
import { FullScreenLoaderEnum } from '@enums/fullscreen-loader.enum';

export const selectFullscreenLoader = (state: AppState): FullscreenLoaderModel => state.fullscreenLoader;

export const selectFullscreenLoaderVisibility = createSelector(selectFullscreenLoader, ({ isVisible }: FullscreenLoaderModel) => isVisible);

export const selectFullscreenLoaderProps = createSelector(
  selectFullscreenLoader,
  ({ loaderType, contentfulMessageKey, contentfulBody }: FullscreenLoaderModel) => ({
    loaderType: loaderType || FullScreenLoaderEnum.DEFAULT,
    messageKey: contentfulMessageKey || null,
    contentfulBody: contentfulBody || null,
  })
);
